import axiosClient from "..";
class invoiceAPi {
    static invoiceShareAPI(data) {
        return axiosClient.post("/api/admin/pos/sales/send_invoice_pdf.pdf", data);
    }
}
export default invoiceAPi;